import avatarMissing from "soapbox/assets/images/avatar-missing.png";
import headerMissing from "soapbox/assets/images/header-missing.png";

import type { Account } from "soapbox/schemas/index.ts";

const getDomainFromURL = (account: Pick<Account, "url">): string => {
  try {
    const url = account.url;
    return new URL(url).host;
  } catch {
    return "";
  }
};

/**
 * Check if an account is TrueMapleAds which has special restrictions
 */
export const isTrueMapleAdsAccount = (
  account: Account | null | undefined,
): boolean => {
  if (!account) return false;

  // Check by username (case-insensitive)
  return (
    account.username.toLowerCase() === "truemapleads" ||
    account.acct.toLowerCase() === "truemapleads" ||
    account.acct.toLowerCase().startsWith("truemapleads@")
  );
};

/**
 * Check if follow functionality should be disabled for an account
 */
export const isFollowDisabled = (
  account: Account | null | undefined,
): boolean => {
  return isTrueMapleAdsAccount(account);
};

export const getDomain = (account: Pick<Account, "acct" | "url">): string => {
  const domain = account.acct.split("@")[1];
  return domain ? domain : getDomainFromURL(account);
};

export const getBaseURL = (account: Pick<Account, "url">): string => {
  try {
    return new URL(account.url).origin;
  } catch {
    return "";
  }
};

export const getAcct = (
  account: Pick<Account, "fqn" | "acct">,
  displayFqn: boolean,
): string => (displayFqn === true ? account.fqn : account.acct);

/** Default header filenames from various backends */
const DEFAULT_HEADERS: string[] = [
  "/headers/original/missing.png", // Mastodon
  "/images/banner.png", // Pleroma
  headerMissing, // header not provided by backend
];

const getAssetPathname = (url: string): string => {
  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return url.split("?")[0].split("#")[0];
  }
};

/** Check if the avatar is a default avatar */
export const isDefaultHeader = (url?: string | null) => {
  if (!url) return true;

  const pathname = getAssetPathname(url);

  return DEFAULT_HEADERS.some(
    (header) => pathname.endsWith(header) || url.endsWith(header),
  );
};

/** Default avatar filenames from various backends */
const DEFAULT_AVATARS = [
  "/avatars/original/missing.png", // Mastodon
  "/images/avi.png", // Pleroma
  avatarMissing, // avatar not provided by backend
];

/** Check if the avatar is a default avatar */
export const isDefaultAvatar = (url?: string | null) => {
  if (!url) return true;

  const pathname = getAssetPathname(url);

  return DEFAULT_AVATARS.some(
    (avatar) => pathname.endsWith(avatar) || url.endsWith(avatar),
  );
};
